import Encryptor from "jsencrypt";
// import * as CryptoJS from 'crypto-js';


import { AuthContextType, creditStatusType, paymentBlock, requestBodyForAdminApprovalType, uploadDocumentType, userAccountDetailsType } from "../types/types";
import { EnvironmentRegistry } from "./registry/environmentRegistry";
import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "./networkService";

export async function uploadDocument(formData: FormData) {
    
    const response = await ChannelkartNetworkPost(`/v1/uploadMultipleFiles/images`, formData,{"Content-Type": "multipart/form-data"});
    return response.data;
}

export async function submitUserAccount(userAccountDetails: userAccountDetailsType) {
    const response = await ChannelkartNetworkPost(`/v1/userAccount`, userAccountDetails);
    return response.data;
}

export async function updateUserAccount(userAccountDetails: userAccountDetailsType){
    const response = await ChannelkartNetworkPut(`/v1/userAccount`, userAccountDetails);
    return response.data;
}

export async function userApproval(requestBodyForAdminApproval: requestBodyForAdminApprovalType){
    const response = await ChannelkartNetworkPost(`/v1/userAccount/userApproval`, requestBodyForAdminApproval);
    return response.data;
}


export async function getUserAccount(loginid: string) {
    const response = await ChannelkartNetworkGet(`/v1/query/getUserAccount?loggedInUserName=${loginid}`);
    return response.data;
}

export async function getEntityApproval(loginid: string) {
    const response = await ChannelkartNetworkGet(`/v1/entityApprovals?filter=referenceId:${loginid}&size=8000&sort=lastModifiedTime:desc&page=0`);
    return response.data;
}

export async function getUserAccountPayload(loginid: string) {
    const response = await ChannelkartNetworkGet(`/v1/userAccount?filter=loginId:${loginid}`);
    return response.data;
}

export async function encryptData(data: any): Promise<string> {
    const encryptor = new Encryptor();
    encryptor.setPublicKey("MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCvEbxPHVMhvoI4JVU0twKmV6+D0glCpxrAiN7+sp88xUvhA+IIrirRCGiq+v5rpG3VMJv3N5+Nxm/2JZwwMlw04tdCOoLdsp4iLc+UNq0iTZ5P2W/U7QhsQNDsA+qzPtZC28AUm1mfkNYu+FEkec5vkRxHk4Co7gd5RjGGlzSLmQIDAQAB");
    const encryptedData = encryptor.encrypt(data);
    if (encryptedData === false) {
      throw new Error("Could not encrypt");
    }
    return encryptedData;
  }


  export async function submitSelectedBank(apiBodyLoginid: any,selectedBankName: string) {
    const response = await ChannelkartNetworkPost(`/v1/payments/${selectedBankName}/userEnrollment`, apiBodyLoginid);
    return response.data;
}
export async function submitSelectedBankForAccountSharing(apiBodyLoginid: any,selectedBankName: string) {
    const response = await ChannelkartNetworkPost(`/v1/payments/${selectedBankName}/accountEnrollment`, apiBodyLoginid);
    return response.data;
}

export async function updateSelectedBankForAccountSharing(apiBodyLoginid: any,selectedBankName: string) {
    const response = await ChannelkartNetworkPut(`/v1/payments/${selectedBankName}/accountEnrollment`, apiBodyLoginid);
    return response.data;
}

export async function getCheckedBanks() {
    const response = await ChannelkartNetworkGet(`/v1/payments/all/userEnrollmentStatus`);
    return response.data;
}

export async function getMetadata() {
    const response = await ChannelkartNetworkGet(`/metadata`);
    return response.data;
}

export async function getOutletDetails(loginid: string){
    const response = await ChannelkartNetworkGet(`/v1/query/outletDetailsListPaymentBlocking?loggedInUserName=${loginid}`);
    return response.data;
}

export async function getOutletDetailsOnboarding(loginid: string){
    const response = await ChannelkartNetworkGet(`/v1/query/outletDetailsListOnboarding?loggedInUserName=${loginid}`);
    return response.data;
}

export async function getPaymentEnabledOutlets() {
    const response = await ChannelkartNetworkGet(`/v1/query/checkOnboardedBank`);
    return response.data;
}

export async function getOutletsWithPaymentBlocked() {
    const response = await ChannelkartNetworkGet(`/v1/query/paymentBlocking`);
    return response.data;
}

export async function updatePaymentEnableStatus(emptyArray: creditStatusType[]) {
    const response = await ChannelkartNetworkPut(`/paymentSubscription/enableUpdate`, emptyArray);
    return response.data;
}

export async function getOnboardedStatus(loginid: string){
    const response = await ChannelkartNetworkGet(`/v1/query/listOfOutletsInPaymentSubscription?loggedInUserName=${loginid}`);
    return response.data;
}

export async function getBankNameList(){
    const response = await ChannelkartNetworkGet(`/models/bankNames`);
    return response.data;
}

export async function submitBankNameAdmin(requestBody: any) {
    const response = await ChannelkartNetworkPut(`/metadata/transactionFilter?name=filter`, requestBody);
    return response.data;
}

export async function getPaymentManagementOutlets() {
    const response = await ChannelkartNetworkGet(`/v1/query/paymentManagement`);
    return response.data;
}

export async function updatePaymentBlockStatus(emptyArray: paymentBlock[]) {
    const response = await ChannelkartNetworkPut(`/v1/commonApi/qwikcilver/payment/block`, emptyArray);
    return response.data;
}